import React from 'react';

const StatsBar = ({ stats }) => {
  return (
    <div className="stats-bar">
      <div className="stat-card">
        <div className="stat-label">Total {stats.entityType || 'Items'}</div>
        <div className="stat-value">{stats.total}</div>
      </div>
      <div className="stat-card stat-success">
        <div className="stat-label">Synced</div>
        <div className="stat-value">{stats.synced}</div>
      </div>
      <div className="stat-card stat-warning">
        <div className="stat-label">Pending</div>
        <div className="stat-value">{stats.pending}</div>
      </div>
      <div className="stat-card stat-info">
        <div className="stat-label">Processing</div>
        <div className="stat-value">{stats.processing || 0}</div>
      </div>
      <div className="stat-card stat-danger">
        <div className="stat-label">Errors</div>
        <div className="stat-value">{stats.errors}</div>
      </div>
    </div>
  );
};

export default StatsBar;